// extracted by mini-css-extract-plugin
module.exports =  {"input":"GSt8Ld","inputSrOnly":"r36wK7","focusRing":"HeaivJ","label":"o8pQoW","selected":"lN8AQA"};